import React from 'react';
import { useWeb3 } from '../../context/Web3Context';
import { ACTIVE } from '../../config/networks';
import { Alert } from '../common/StatBox';

// Renders children only if on the correct network. Otherwise shows a switch prompt.
export const NetworkGuard = ({ children, requireConnect = true }) => {
  const { account, rightNetwork, switchNetwork, switching } = useWeb3();

  if (requireConnect && !account) {
    return (
      <Alert type="info">
        Please connect your wallet to continue.
      </Alert>
    );
  }

  if (account && !rightNetwork) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: 32 }}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>⚠️</div>
        <h3 style={{ marginBottom: 8 }}>Wrong Network</h3>
        <p style={{ color: 'var(--text-secondary)', marginBottom: 20 }}>
          Please switch to <b>{ACTIVE.displayName}</b> to use this app.
        </p>
        <button className="btn btn-primary" onClick={switchNetwork} disabled={switching}>
          {switching && <span className="btn-spinner" />}
          Switch Network
        </button>
      </div>
    );
  }

  return children;
};
